import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'service-guarantee',
  name: '服务保障',
  icon: '保',
  group: '商品详情页',
  description: '正品、退款、配送和售后保障',
  defaultProps: {
    items: ['正品保障', '极速退款', '运费险']
  }
}
